var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 212.601,
    height: 212.59724,
    viewBox: "0 0 212.601 212.59724",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,226.77 H 496.062 V 0 H 0 Z",
    id: "path54"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.25,0,0,-1.25,-35.432875,255.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "translate(141.7275,175.7432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 0 0.002 L -28.347,28.348 -56.688,0 l 28.341,-28.346 28.343,-28.344 0.008,0.008 z",
    style: {
      fill: "#ee2528",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g16",
    transform: "translate(141.7354,119.0527)",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -0.004,56.692 28.342,28.345 Z",
    style: {
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g20",
    transform: "translate(170.0771,90.7109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 0 H 0.002 L 28.35,28.347 0,56.688 -28.346,28.347 -56.69,0.004 l 0.009,-0.008 z",
    style: {
      fill: "#6ec72e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g24",
    transform: "translate(113.3867,90.7021)",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 56.692,0.004 28.345,-28.342 Z",
    style: {
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28",
    transform: "translate(85.043,62.3604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 0 -0.002 L 28.348,-28.347 56.688,0 28.348,28.346 0.004,56.691 -0.004,56.682 Z",
    style: {
      fill: "#38a7e4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g32",
    transform: "translate(85.0352,119.0518)",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 0.004,-56.693 -28.346,28.347 z",
    style: {
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g36",
    transform: "translate(56.6953,147.3955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 0 H -0.002 L -28.349,-28.348 0,-56.689 28.346,-28.348 56.69,-0.004 56.681,0.004 Z",
    style: {
      fill: "#fbc710",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "translate(113.3857,147.4033)",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -56.692,-0.004 28.347,28.346 z",
    style: {
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(221.1025,146.4473)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8f6714b5b82ca87ac3f2af9275580a24.svg";
export { ForwardRef as ReactComponent };